import { cn } from '@/lib/utils'
import { Info } from 'lucide-react'
import type { ReactNode } from 'react'

interface WhatIsThisProps {
  children: ReactNode
  className?: string
}

/** Soft banner that explains a page in plain English for non-technical admins. */
export function WhatIsThis({ children, className }: WhatIsThisProps) {
  return (
    <div
      className={cn(
        'mb-6 flex gap-3 rounded-xl border border-primary/15 bg-primary/[0.04] p-3 text-sm text-foreground',
        className
      )}
    >
      <Info className="mt-0.5 size-4 shrink-0 text-primary" />
      <p className="leading-relaxed text-muted-foreground">{children}</p>
    </div>
  )
}
